"use strict";

export const DWHAPI = new function () {
    const self = this;
    const _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI('DWHServers'));

    self.trackEvent = async function (event) {
        const deferred = $q.defer();

        _protected.request('events', 'POST', event)
            .then(function (res) {
                if (res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };

};